// The Swift mark — COSM line-art (per-feather chord rule): line segments + agent vertices tracing a
// swift in flight. The source art is recoloured to currentColor (assets/athletic-swift.svg) so it
// inherits the page ink — WHITE on the dark skin, BLACK on the light skin. One component, two homes:
// the pre-login landing hero (where it DRAWS ITSELF, line by line) and a faint, static watermark on
// the post-login canvas field.
//
// The FIGURE lives here (the inlined asset + the ecosystem framing); the DRAW is the shell's
// <DrawnMark> engine — this component's original rAF implementation was ported UP as that engine,
// so every app's landing (narratives' S, this swift) now draws on the same beat (MARK_DRAW_MS)
// with the same contract: `animate`, `duration` (the splash passes a faster one), `direction`
// ('out' UNDRAWS on an app-hop exit), reduced-motion → the finished figure.
import { DrawnMark } from '@ofself/shell'
import raw from '../assets/athletic-swift.svg?raw'
import './AthleticSwift.css'

// The mark framed to the ecosystem's COMMON field-mark height. The asset's own
// viewBox (39 28 170 170) packs the bird tight, so in the shell's shared
// --field-mark-size box it renders ~33% taller than narratives' S-mark and the
// design cinquefoil. This padded square re-centres the bird and lands it at the
// SAME rendered height (~530px in the 846px box), matching the other apps' marks.
const FIELD_VIEWBOX = '10 -1 225 225'

export default function AthleticSwift({ className = '', animate = false, viewBox = FIELD_VIEWBOX, duration, direction = 'in' }) {
  return (
    <DrawnMark
      svg={raw}
      viewBox={viewBox}
      animate={animate}
      duration={duration}
      direction={direction}
      className={`swift-mark ${className}`.trim()}
    />
  )
}
